import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./assets/style/style.scss" ;
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import NumberProvider from './content/NumberContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <NumberProvider>
    <App />
    </NumberProvider>
  </>
);

